<template>
  <iq-card
    class-name="iq-card-block iq-card-stretch"
    body-class=""
    class="p-3"
    id="quickQuotePage"
  >
    <div class="row">
      <div class="col-12">
        <h4 class="text-info fw-600 mb-3">BDM Commission View / Download</h4>
      </div>
    </div>
    <b-row>
      <div class="col-12">
        <div class="form-group">
          <label for="paginate" class="mb-0">Stake holder type</label>
          <select v-model="stakeHolderType" class="form-control sits_select">
            <option value="">Select</option>
            <option value="de">Dealer</option>
            <!-- <option value="rp">Referral Partner</option> -->
          </select>
          <div class="invalid-feedback" v-if="errors.stakeHolderType">
            {{ errors.stakeHolderType[0] }}
          </div>
        </div>
      </div>

      <b-col lg="12" md="12" sm="12">
        <div class="d-flex">
          <div class="pr-2">
            <label class="mb-0" for="noteOnOtherIncome">Year</label>
            <datePicker
              type="year"
              :editable="true"
              value-type="YYYY"
              format="YYYY"
              placeholder="YYYY"
              v-model="commissionYear"
            >
            </datePicker>
            <div class="invalid-feedback" v-if="errors.commissionYear">
              {{ errors.commissionYear[0] }}
            </div>
          </div>
          <div class="pl-2">
            <label class="mb-0" for="noteOnOtherIncome">Month</label>
            <datePicker
              type="month"
              :editable="true"
              format="MM"
              placeholder="MM"
              value-type="MM"
              v-model="commissionMonth"
            >
            </datePicker>
            <div class="invalid-feedback" v-if="errors.commissionMonth">
              {{ errors.commissionMonth[0] }}
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-12 text-right mt-3">
        <button class="btn btn-primary btn-sm mr-2" @click="fnView()">
          View
        </button>
      </div>
    </div>
  </iq-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import datePicker from 'vue2-datepicker'
export default {
  name: 'InvoiceView',
  components: {
    datePicker
  },
  data() {
    return {
      errors: {},
      commissionYear: '',
      commissionMonth: '',
      stakeHolderType: '',
      loading: false,
      referredByBDM: -1
    }
  },
  computed: {
    ...mapGetters(['getBDMCommissions'])
  },

  methods: {
    ...mapActions(['fetchBDMCommissionParam', 'fetchBDMCommissions']),
    async fnView() {
      this.errors = {}
      let dataObj = {
        commissionYear: this.commissionYear,
        commissionMonth: this.commissionMonth,
        stakeHolderType: this.stakeHolderType
      }
      this.fetchBDMCommissionParam(dataObj)
      this.fetchBDMCommissions(dataObj)
    }
  },
  watch: {
    getBDMCommissions(val) {
      this.errors = val?.errors
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
